import { BrowserRouter as Router } from "react-router";
import { PrimeReactProvider } from "primereact/api";
import { ScrollToTop } from "./components/common/ScrollToTop";
import { Toaster } from "react-hot-toast";
import AppRouter from "./routes/router";
import AuthProvider from "./components/auth/AuthProvider";
import "@khmyznikov/pwa-install";
import "./App.css";
// import PwaInstallPopupIOS from "react-pwa-install-ios";
// Inner component that has access to Redux dispatch
function AppContent() {
  return (
    <Router>
      {/* <PwaInstallPopupIOS
        delay={3}
        lang="en"
        appIcon="https://my/icon/url.png"
      ></PwaInstallPopupIOS> */}
      {/* <pwa-install
        disable-close="false"
        use-local-storage="true"
        name="Wewear Wellness Application"
        manifest-url="/manifest.json"
        install-description="Install this app for faster access!"
        icon="https://software.whubjourney.com/logo512.png"
      ></pwa-install> */}
      <PrimeReactProvider>
        <AuthProvider>
          <ScrollToTop />
          <Toaster
            position="top-right"
            reverseOrder={false}
            toastOptions={{
              duration: 4000,
              style: {
                background: "#363636",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "14px",
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: "#4aed88",
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: "#ff4b4b",
                },
              },
              loading: {
                duration: Infinity,
              },
            }}
          />
          <AppRouter />
        </AuthProvider>
      </PrimeReactProvider>
    </Router>
  );
}

// Main App component with Redux Provider
export default function App() {
  return <AppContent />;
}
